export default "__VITE_ASSET__Bhz5LxEe__"